import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "d-flex flex-column mb-8 fv-row" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center fs-6 fw-bold mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Názov stavu")
], -1)
const _hoisted_3 = { class: "row g-9 mb-8" }
const _hoisted_4 = { class: "col-md-3 fv-row" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", { class: "required fs-6 fw-bold mb-2" }, "Farba pozadia", -1)
const _hoisted_6 = { class: "col-md-3 fv-row" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", { class: "required fs-6 fw-bold mb-2" }, "Farba písma", -1)
const _hoisted_8 = { class: "col-md-3 fv-row" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { class: "required fs-6 fw-bold mb-2" }, "Odoslať e-mail", -1)
const _hoisted_10 = {
  key: 0,
  class: "col-md-3 fv-row"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", { class: "required fs-6 fw-bold mb-2" }, "Odoslať faktúru", -1)
const _hoisted_12 = {
  key: 0,
  class: "d-flex flex-column mb-8 fv-row"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center fs-6 fw-bold mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Nadpis e-mailu")
], -1)
const _hoisted_14 = {
  key: 1,
  class: "d-flex flex-column mb-8 fv-row"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center fs-6 fw-bold mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Text e-mailu")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_color_picker = _resolveComponent("el-color-picker")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_ckeditor = _resolveComponent("ckeditor")!
  const _component_npxForm = _resolveComponent("npxForm")!

  return (_openBlock(), _createBlock(_component_npxForm, {
    cardWrapper: "1",
    pageTitleNew: "Nový stav objednávky",
    pageSubtitleNew: "Vyplňte povinné polia, pre pridanie nového stavu objednávky.",
    pageTitleEdit: "Upraviť stav objednávky",
    pageSubtitleEdit: "Vyplňte povinné polia, pre úpravu stavu objednávky.",
    listPageRouter: "statuses",
    firestoreCollection: "statuses",
    fieldValues: _ctx.localFieldValues,
    fieldRules: _ctx.localFieldRules
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createVNode(_component_el_form_item, { prop: "title" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _ctx.localFieldValues.title,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.localFieldValues.title) = $event)),
              placeholder: "Vložte názov stavu",
              name: "title"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createVNode(_component_el_form_item, { prop: "bgColor" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_color_picker, {
                modelValue: _ctx.localFieldValues.bgColor,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.localFieldValues.bgColor) = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _createVNode(_component_el_form_item, { prop: "fontColor" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_color_picker, {
                modelValue: _ctx.localFieldValues.fontColor,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.localFieldValues.fontColor) = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_8, [
          _hoisted_9,
          _createVNode(_component_el_form_item, { prop: "sendEmail" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_switch, {
                modelValue: _ctx.localFieldValues.sendEmail,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.localFieldValues.sendEmail) = $event)),
                "active-text": "áno",
                "inactive-text": "nie"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          })
        ]),
        (_ctx.localFieldValues.sendEmail == true)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _hoisted_11,
              _createVNode(_component_el_form_item, { prop: "sendInvoice" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_switch, {
                    modelValue: _ctx.localFieldValues.sendInvoice,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.localFieldValues.sendInvoice) = $event)),
                    "active-text": "áno",
                    "inactive-text": "nie"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true)
      ]),
      (_ctx.localFieldValues.sendEmail == true)
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
            _hoisted_13,
            _createVNode(_component_el_form_item, { prop: "emailSubject" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.localFieldValues.emailSubject,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.localFieldValues.emailSubject) = $event)),
                  placeholder: "Vložte nadpis e-mailu",
                  name: "emailSubject"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true),
      (_ctx.localFieldValues.sendEmail == true)
        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
            _hoisted_15,
            _createVNode(_component_el_form_item, { prop: "emailBody" }, {
              default: _withCtx(() => [
                _createVNode(_component_ckeditor, {
                  editor: _ctx.editor,
                  modelValue: _ctx.localFieldValues.emailBody,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.localFieldValues.emailBody) = $event)),
                  config: _ctx.editorConfig
                }, null, 8, ["editor", "modelValue", "config"])
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["fieldValues", "fieldRules"]))
}